import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appToggleText]',
})
export class ToggleTextDirective implements OnInit {
  @Input('appToggleText') text: string = '';
  @Input() maxLength: number = 50;
  @Input() styleClass: string = 'rts-toggle-text';
  @Input() lessClass: string = 'rts-toggle-text-less';
  @Input() moreClass: string = 'rts-toggle-text-more';
  @Input() lessBtnText: string = 'Скрыть';
  @Input() moreBtnText: string = 'Показать ещё';

  private isExpanded = false;
  private fullText: string = '';

  constructor(private _el: ElementRef, private _renderer: Renderer2) {}

  public ngOnInit(): void {
    if (this.text?.length) {
      this.fullText = this.text;
      this._updateText();
    }
  }

  @HostListener('click') toggleText(): void {
    this.isExpanded = !this.isExpanded;
    this._updateText();
  }

  private _updateText(): void {
    const displayText = this.isExpanded
      ? this.fullText
      : this.fullText.substring(0, this.maxLength);
    const toggleLabel = this.isExpanded ? this.lessBtnText : this.moreBtnText;
    const toggleClass = this.isExpanded ? this.moreClass : this.lessClass;

    this._renderer.setProperty(
      this._el.nativeElement,
      'innerHTML',
      `${displayText} ${
        this._shouldShowButton() ? `<span class="${this.styleClass}">${toggleLabel}</span>` : ''
      }`
    );

    const toggleButton = this._el.nativeElement.querySelector(`.${this.styleClass}`);
    if (toggleButton) {
      this._renderer.removeClass(toggleButton, this.lessClass);
      this._renderer.removeClass(toggleButton, this.moreClass);
      this._renderer.addClass(toggleButton, toggleClass);
    }
  }

  private _shouldShowButton(): boolean {
    return this.fullText.length > this.maxLength;
  }
}
